module.exports = __webpack_public_path__ + "static/img/function-box-img5.d92b551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/function-box-img5.png
// module id = UeTE
// module chunks = 0